import React, { Component } from 'react';

export default class QR_Scanner extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}

		// Inside system menu, first prepare the qrscanner,
		// If not authorised, just close the modal
		window.QRScanner.prepare(this.onDone); // show the prompt
		// Hide loading when qrscanner is activated
		window.app.hideLoading();
	}

	onDone = (err, status) => {

		// Tommy - 05/04/2021 - User selects "Allow"
		if (err == null) {
			// here we can handle errors and clean up any loose ends.
			if (status.authorized) {
				// W00t, you have camera access and the scanner is initialized.
				window.QRScanner.show();
				window.app.content_area.current.switch_content.current.showQRScanner();
				window.QRScanner.getStatus(function (status) {
					//console.log(status);
				});
				window.QRScanner.scan(this.onScanComplete);
			}
		} else {
			//  User selects "Deny" or "Deny & Don't ask again"
			window.app.content_area.current.switch_content.current.hideQRScanner();
			window.app.showToast(this.props.receiver.getString('permission_fail'), 3000);
			let param = this.props.param;
			let from = this.props.param.from;
			param.from = this.props.param.original_from;
			delete param.original_from;
			window.app.content_area.current.content_handler(from, param);
		}
	}

	onScanComplete = (err, text) => {
		let controller_info = null;
		if (err) {
			// an error occurred, or the scan was canceled (error code `6`)	  
			console.log('error')
		} else {
			// The scan completed, display the contents of the QR code:
			try {
				controller_info = JSON.parse(window.atob(text));
			} catch (err) {
				window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
			}
		}

		window.app.content_area.current.switch_content.current.hideQRScanner();
		let param = this.props.param;
		let from = this.props.param.from;
		param.from = this.props.param.original_from;
		delete param.original_from;
		param.controller_info = controller_info;
		window.app.content_area.current.content_handler(from, param);
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div>
			</div>
		)
	}
}